<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash" @del="batchDel" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
				id="xpane-0"
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="false"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				@cell-dblclick="editInfo"
				tab-click="selectInfo(0)"
				header-row-class-name="headerclass"
				@selection-change="handleSelectionChange"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="balance_mode" :label="$t('getapi[1228]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="currency" :label="$t('getapi[8339]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="banknum" :label="$t('getapi[13379]')" width="100px"></el-table-column>
			<el-table-column show-overflow-tooltip prop="subject" :label="$t('getapi[13380]')" width="100px"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope" >
					<el-button  @click.native.prevent="editInfo(scope.row)"  type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
							:confirmButtonText="$t('getapi[937]')"
							:cancelButtonText="$t('getapi[6]')"
							icon="el-icon-info"
							iconColor="red"
							:title="$t('getapi[637]')"
							@onConfirm="del(scope)"
					>
						<el-button  slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300, 400]"
						:page-size="PageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[1228]')}}</td>
						<td>
							<el-select filterable v-model="dataList.balance_mode" size="mini">
								<el-option v-for="(item, index) in BalanceMode" :label="item.balance_mode"
										   :value="item.balance_mode" :key="index" ></el-option>
							</el-select>
						</td>
						<td>{{$t('getapi[8339]')}}</td>
						<td>
							<el-select filterable v-model="dataList.currency" size="mini">
								<el-option v-for="(item, index) in Currency" :label="item.currency_code"
										   :value="item.currency_code" :key="index" ></el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[13379]')}}</td>
						<td>
							<el-select filterable v-model="dataList.banknum" size="mini">
								<el-option v-for="(item, index) in BankAccount" :label="item.banknum"
										   :value="item.banknum" :key="index" ></el-option>
							</el-select>
						</td>
						<td>{{$t('getapi[13380]')}}</td>
						<td><el-input v-model="dataList.subject" type="text" size="mini" ></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name: 'billingoptions',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: '',
                dataSet: [],
                dataList: {},
                PageIndex: 1,
                PageSize: this.$http.getPageSize('billingoptions'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: '',
                btn: {
                    del: false,
                    edit: false
                },
                scrollTop:0,
                Currency:[], //货币数组
				BalanceMode:[],//结算方式数组
                BankAccount:[],//本单位银行账号数组
            };
        },
        create() {},
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.BalanceMode = Array.methods.GetBillingOptionsList()
            that.BankAccount = Array.methods.GetBankAccountList()
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8236]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del')
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('billingoptions',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true;
                let datetime = Common.methods.getDatetime()
                that.dataList = {
                    Exclusively_ID: row.Exclusively_ID,
                    type: row.type,
                    balance_mode: row.balance_mode,
                    currency:row.currency,
                    banknum:row.banknum,
                    subject:row.subject,
                    Create_Person: row.Create_Person,
                    Create_Time: row.Create_Time,
                    Modify_Person: that.user,
                    Modify_Time: datetime,
                };
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
//				}
                });
                that.$http.urlpost('/GL/Basic/GetBillingSubject', parm, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                that.dataList.type = 1
                let parm = that.dataList
                that.$http.urlpost('/GL/Basic/SaveBillingSubject', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
                    that.queryData = res.DataContent;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = ''
                let str = '';
                for (let i = 0; i < val.length; i++) {
                    str += val[i].Exclusively_ID + ',';
                }
                that.selectIDData = str.substr(0,str.length - 1)
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('/GL/Basic/DeleteBillingSubjectByID', parm, function(res) {
                    that.getView();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.Exclusively_ID + ',';
                this.ids = this.ids.substr(0,this.ids.length - 1)
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {});
            },
            // 新增
            add() {
                let that = this;
                that.isVisible = true;
                let datetime = Common.methods.getDatetime()
                that.dataList = {
                    Exclusively_ID: '',
                    type: '',
                    balance_mode: '',
                    currency:'',
                    banknum:'',
                    subject:'',
                    Create_Person: that.user,
                    Create_Time: datetime,
                    Modify_Person: '',
                    Modify_Time: '',
                };
            },
            // 刷新
            reflash() {
                this.getView();
            }
        }
    };
</script>

<style lang="scss" scoped>

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
	.el-form--inline .el-form-item {
		display: flex;
	}

	.tb-edit .el-input {
		display: none;
	}

	.tb-edit .current-row .el-input {
		display: block;
	}

	.tb-edit .current-row .el-input + span {
		display: none;
	}

	.el-table .hidden-row {
		display: none;
	}
</style>
